const ACTION_LABELS = {
  "access_request.status_changed": "Changed access request status",
  "access_request.submitted": "Submitted access request",
  "auth.sign_in": "Signed in",
  "bank_account.create": "Added bank account",
  "bank_account.delete": "Deleted bank account",
  "bank_account.update": "Updated bank account",
  "company.coc_fee_paid": "Marked Chamber of Commerce fee paid",
  "company.create": "Created company",
  "company.delete": "Deleted company",
  "company.purge": "Permanently deleted company",
  "company.restore": "Restored company",
  "company.status_update": "Changed company status",
  "company.update": "Updated company",
  "company_address.create": "Added company address",
  "company_address.delete": "Deleted company address",
  "company_address.update": "Updated company address",
  "deviezen.create": "Created foreign exchange permit",
  "deviezen.update": "Updated foreign exchange permit",
  "document.create": "Uploaded document",
  "document.delete": "Deleted document",
  "document.download": "Downloaded document",
  "document.update": "Updated document",
  "export.run": "Exported data",
  "feedback.status_changed": "Changed feedback status",
  "feedback.submitted": "Submitted feedback",
  "impersonation.start": "Started impersonation",
  "impersonation.stop": "Stopped impersonation",
  "invitation.resend": "Resent invitation",
  "invitation.revoke": "Revoked invitation",
  "member.activate": "Activated member",
  "member.remove": "Removed member",
  "member.role_change": "Changed member role",
  "member.suspend": "Suspended member",
  "permission.grant": "Granted permission",
  "permission.revoke": "Revoked permission",
  "person.document.download": "Downloaded person document",
  "person_address.create": "Added person address",
  "person_address.delete": "Deleted person address",
  "person_address.update": "Updated person address",
  "portal.document.download": "Downloaded portal document",
  "portal.tenant.logo_upload": "Uploaded tenant logo",
  "review.create": "Created review",
  "review.delete": "Deleted review",
  "review.update": "Updated review",
  "screening.create": "Created screening",
  "screening.delete": "Deleted screening",
  "screening.update": "Updated screening",
  "session.devices_kicked": "Signed out other devices",
  "tax_year.create": "Added tax year",
  "tax_year.update": "Updated tax year",
  "tenant.activate": "Activated tenant",
  "tenant.close": "Closed tenant",
  "tenant.clerk_org.create": "Created identity organization",
  "tenant.clerk_org.link": "Linked identity organization",
  "tenant.create": "Created tenant",
  "tenant.member.role_update": "Changed member role",
  "tenant.member.upsert": "Provisioned identity-organization member",
  "tenant.provision": "Provisioned tenant",
  "tenant.provision_clerk_org": "Provisioned identity organization",
  "tenant.seats.update": "Changed tenant seat limit",
  // Legacy operational rows retained for display; these are no longer emitted.
  "tenant.seats.clerk_sync": "Reconciled tenant seats with identity provider",
  "tenant.seats.clerk_sync_failed": "Failed to reconcile tenant seats with identity provider",
  "tenant.seats.clerk_sync_skipped": "Skipped tenant seat reconciliation",
  "tenant.status_update": "Changed tenant status",
  "tenant.suspend": "Suspended tenant",
  "tenant.trial": "Moved tenant to trial",
  "user.invite": "Invited user",
  "waiver.create": "Created waiver",
  "waiver.delete": "Deleted waiver",
};

const WORD_OVERRIDES = { coc: "Chamber of Commerce", id: "ID", ip: "IP", url: "URL" };

export function humanizeAuditAction(action) {
  if (!action) return "Recorded activity";
  if (ACTION_LABELS[action]) return ACTION_LABELS[action];
  const words = String(action).split(/[._-]+/).filter(Boolean);
  if (!words.length) return "Recorded activity";
  const readable = words.map((word) => WORD_OVERRIDES[word.toLowerCase()] || word.toLowerCase()).join(" ");
  return readable.charAt(0).toUpperCase() + readable.slice(1);
}

export function humanizeAuditKey(key) {
  const words = String(key || "").replace(/([a-z0-9])([A-Z])/g, "$1 $2").split(/[._-]+/).filter(Boolean);
  return words.map((word) => WORD_OVERRIDES[word.toLowerCase()] || `${word.charAt(0).toUpperCase()}${word.slice(1)}`).join(" ");
}

export function formatAuditValue(value) {
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (value === null || value === undefined || value === "") return null;
  return String(value);
}

export function formatRole(role) {
  if (!role) return null;
  return humanizeAuditKey(role);
}

export function getActorDisplay(entry) {
  const fullName = [entry?.actorFirstName, entry?.actorLastName].filter(Boolean).join(" ").trim();
  if (fullName) return fullName;
  if (entry?.actorEmail) return entry.actorEmail;
  if (entry?.actorUserId) return `User #${entry.actorUserId}`;
  return "System";
}

export function getTargetSummary(entry) {
  const metadata = entry?.metadata && typeof entry.metadata === "object" && !Array.isArray(entry.metadata) ? entry.metadata : {};
  const name = metadata.targetName || metadata.companyName || metadata.company_name || metadata.name || metadata.title || metadata.filename || metadata.fileName || metadata.email;
  const type = humanizeAuditKey(entry?.targetType || "resource").toLowerCase();
  if (name) return `${humanizeAuditKey(entry?.targetType || "resource")} “${name}”`;
  if (entry?.targetId) return `${humanizeAuditKey(entry?.targetType || "resource")} #${entry.targetId}`;
  return type === "resource" ? "—" : humanizeAuditKey(entry.targetType);
}

export { ACTION_LABELS };
